// Thin wrapper around authenticatedFetch. Mirrors TeamaticalPrep/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/inventory-rebalancing';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try {
      const raw = await resp.text();
      try {
        const d = JSON.parse(raw).detail;
        detail = typeof d === 'string' ? d : d?.message ? d.message : raw;
      } catch {
        detail = raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240);
      }
    } catch { /* status alone is enough */ }
    const err = new Error(detail || `${resp.status} ${resp.statusText}`);
    err.status = resp.status;
    throw err;
  }
  return resp.json();
}

const postJson = (path, body) => authenticatedFetch(`${BASE}${path}`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
}).then(jsonOrThrow);

export const api = {
  meta: () => authenticatedFetch(`${BASE}/meta`).then(jsonOrThrow),
  status: () => authenticatedFetch(`${BASE}/status`).then(jsonOrThrow),
  report: (body) => postJson('/report', body),
  enginesMeta: () => authenticatedFetch(`${BASE}/engines/meta`).then(jsonOrThrow),
  v2Report: (body) => postJson('/v2/report', body),
  aiReport: (body) => postJson('/ai/report', body),
  validate: (itemIds, shopIds) => postJson('/validate', { item_ids: itemIds, shop_ids: shopIds }),
  // dryRun true returns the transfer documents that would be created; false creates them in Lightspeed.
  // reportId ties the transfers to the report run they came from, in the log.
  transfers: (lines, dryRun, reportId) => postJson('/transfers', { transfers: lines, dry_run: dryRun, report_id: reportId ?? null }),
  sync: (kind) => postJson('/sync', { kind }),
  // A ✓ or ✗ on one report line, with the typed reason (kept in Inventory Movement Knowledge).
  feedback: (body) => postJson('/feedback', body),
  reportFeedback: (reportId) => authenticatedFetch(`${BASE}/reports/${reportId}/feedback`).then(jsonOrThrow),
};
